import React, { useState } from "react";
import moment from "moment";

const CostingCargoValidator = (props) => {
  const record = props.data.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";

  if (!error && !record.originAirportCode) {
    error = true;
    errorMessage = "'Origin Airport Code' is required";
  }
  if (!error && !record.destinationAirportCode) {
    error = true;
    errorMessage = "'Destination Airport Code' is required";
  }

  if (!error && !record.payloadLoose && !record.payloadUnitised) {
    error = true;
    errorMessage = "'Loose or Unitised consignment weight is required' is required";
  }

  if (!error && record.payloadUnitised && !record.bupCount) {
    error = true;
    errorMessage = "'BUP Count' is required for unitised cargo";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default CostingCargoValidator;
